import { render, staticRenderFns } from "./addContactDialog.vue?vue&type=template&id=e567d1d2"
import script from "./addContactDialog.vue?vue&type=script&lang=js"
export * from "./addContactDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports